import { render } from "./wanfazhuangtai.vue?vue&type=template&id=338209d1&scoped=true"
import script from "./wanfazhuangtai.vue?vue&type=script&lang=js"
export * from "./wanfazhuangtai.vue?vue&type=script&lang=js"

import "./wanfazhuangtai.vue?vue&type=style&index=0&id=338209d1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338209d1"]])

export default __exports__